/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UpcomingRouteImport } from './routes/upcoming'
import { Route as TodayRouteImport } from './routes/today'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as SearchRouteImport } from './routes/search'
import { Route as QuickbarRouteImport } from './routes/quickbar'
import { Route as LoginRouteImport } from './routes/login'
import { Route as InboxRouteImport } from './routes/inbox'
import { Route as IndexRouteImport } from './routes/index'
import { Route as TagsIdRouteImport } from './routes/tags.$id'
import { Route as ReportsWeeklyRouteImport } from './routes/reports.weekly'
import { Route as ProjectsIdRouteImport } from './routes/projects.$id'

const UpcomingRoute = UpcomingRouteImport.update({
  id: '/upcoming',
  path: '/upcoming',
  getParentRoute: () => rootRouteImport,
} as any)
const TodayRoute = TodayRouteImport.update({
  id: '/today',
  path: '/today',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const SearchRoute = SearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => rootRouteImport,
} as any)
const QuickbarRoute = QuickbarRouteImport.update({
  id: '/quickbar',
  path: '/quickbar',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const InboxRoute = InboxRouteImport.update({
  id: '/inbox',
  path: '/inbox',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TagsIdRoute = TagsIdRouteImport.update({
  id: '/tags/$id',
  path: '/tags/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsWeeklyRoute = ReportsWeeklyRouteImport.update({
  id: '/reports/weekly',
  path: '/reports/weekly',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsIdRoute = ProjectsIdRouteImport.update({
  id: '/projects/$id',
  path: '/projects/$id',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/inbox': typeof InboxRoute
  '/login': typeof LoginRoute
  '/quickbar': typeof QuickbarRoute
  '/search': typeof SearchRoute
  '/settings': typeof SettingsRoute
  '/today': typeof TodayRoute
  '/upcoming': typeof UpcomingRoute
  '/projects/$id': typeof ProjectsIdRoute
  '/reports/weekly': typeof ReportsWeeklyRoute
  '/tags/$id': typeof TagsIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/inbox': typeof InboxRoute
  '/login': typeof LoginRoute
  '/quickbar': typeof QuickbarRoute
  '/search': typeof SearchRoute
  '/settings': typeof SettingsRoute
  '/today': typeof TodayRoute
  '/upcoming': typeof UpcomingRoute
  '/projects/$id': typeof ProjectsIdRoute
  '/reports/weekly': typeof ReportsWeeklyRoute
  '/tags/$id': typeof TagsIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/inbox': typeof InboxRoute
  '/login': typeof LoginRoute
  '/quickbar': typeof QuickbarRoute
  '/search': typeof SearchRoute
  '/settings': typeof SettingsRoute
  '/today': typeof TodayRoute
  '/upcoming': typeof UpcomingRoute
  '/projects/$id': typeof ProjectsIdRoute
  '/reports/weekly': typeof ReportsWeeklyRoute
  '/tags/$id': typeof TagsIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/inbox'
    | '/login'
    | '/quickbar'
    | '/search'
    | '/settings'
    | '/today'
    | '/upcoming'
    | '/projects/$id'
    | '/reports/weekly'
    | '/tags/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/inbox'
    | '/login'
    | '/quickbar'
    | '/search'
    | '/settings'
    | '/today'
    | '/upcoming'
    | '/projects/$id'
    | '/reports/weekly'
    | '/tags/$id'
  id:
    | '__root__'
    | '/'
    | '/inbox'
    | '/login'
    | '/quickbar'
    | '/search'
    | '/settings'
    | '/today'
    | '/upcoming'
    | '/projects/$id'
    | '/reports/weekly'
    | '/tags/$id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  InboxRoute: typeof InboxRoute
  LoginRoute: typeof LoginRoute
  QuickbarRoute: typeof QuickbarRoute
  SearchRoute: typeof SearchRoute
  SettingsRoute: typeof SettingsRoute
  TodayRoute: typeof TodayRoute
  UpcomingRoute: typeof UpcomingRoute
  ProjectsIdRoute: typeof ProjectsIdRoute
  ReportsWeeklyRoute: typeof ReportsWeeklyRoute
  TagsIdRoute: typeof TagsIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/upcoming': {
      id: '/upcoming'
      path: '/upcoming'
      fullPath: '/upcoming'
      preLoaderRoute: typeof UpcomingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/today': {
      id: '/today'
      path: '/today'
      fullPath: '/today'
      preLoaderRoute: typeof TodayRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/search': {
      id: '/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof SearchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/quickbar': {
      id: '/quickbar'
      path: '/quickbar'
      fullPath: '/quickbar'
      preLoaderRoute: typeof QuickbarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inbox': {
      id: '/inbox'
      path: '/inbox'
      fullPath: '/inbox'
      preLoaderRoute: typeof InboxRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tags/$id': {
      id: '/tags/$id'
      path: '/tags/$id'
      fullPath: '/tags/$id'
      preLoaderRoute: typeof TagsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports/weekly': {
      id: '/reports/weekly'
      path: '/reports/weekly'
      fullPath: '/reports/weekly'
      preLoaderRoute: typeof ReportsWeeklyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/$id': {
      id: '/projects/$id'
      path: '/projects/$id'
      fullPath: '/projects/$id'
      preLoaderRoute: typeof ProjectsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  InboxRoute: InboxRoute,
  LoginRoute: LoginRoute,
  QuickbarRoute: QuickbarRoute,
  SearchRoute: SearchRoute,
  SettingsRoute: SettingsRoute,
  TodayRoute: TodayRoute,
  UpcomingRoute: UpcomingRoute,
  ProjectsIdRoute: ProjectsIdRoute,
  ReportsWeeklyRoute: ReportsWeeklyRoute,
  TagsIdRoute: TagsIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
